import { ServiceProxyConfig } from "./serviceproxyconfig"
import { AxiosRequestConfig, AxiosResponse } from "axios"
import ajax from "@/lib/ajax"
import Util from "@/lib/util"
import AppConsts from "@/lib/appconst"
import appconst from "@/lib/appconst"
import url from "@/lib/url"
import { AbpApiResponse } from "@/store/models/common"
import Vue from "vue"
import store from "@/store"
import { IUserLoginInfoDto } from "./apiproxy.dto"

export class ServiceProxyBase extends Vue {


  constructor(configuration?: ServiceProxyConfig) {
    super()
    // if (!!configuration) {
    //   //this.instance.request({ baseURL: configuration.hostUrl });
    // }
  }

  store = store;

  public get currentUser(): IUserLoginInfoDto {
    return this.store.state.session.user;
  }

  public getBaseUrl(defaultUrl: string): string {
    return AppConsts.remoteServiceBaseUrl
  }

  public async transformOptions(options: AxiosRequestConfig) {
    const config = options
    // /**** copy code from ajax.ts *******/
    // const tenantNameRegex = /\/\/(http[0-9]?\/)?(.[^./:]+)/g
    // const matches = tenantNameRegex.exec(url)
    // let tokenAuthBkp = Util.abp.utils.getCookieValue(`${appconst.authorization.encrptedAuthTokenName}_backup`)

    // const token = window.abp.auth.getToken() || (tokenAuthBkp ? window.abp.auth.setToken(tokenAuthBkp) : null)
    // if (tokenAuthBkp) {
    //   Util.abp.utils.deleteCookie(`${appconst.authorization.encrptedAuthTokenName}_backup`)
    //   tokenAuthBkp = null
    // }
    // if (!!token) {
    //   // removed 'common' from config.headers.common

    //   config.headers["Authorization"] = "Bearer " + token
    //   //abp.log.debug({"auth header:":config.headers.common["Authorization"]});
    // }
    // config.headers[".AspNetCore.Culture"] = window.abp.utils.getCookieValue("Abp.Localization.CultureName")

    // const tenantId = window.abp.multiTenancy.getTenantIdCookie()

    // if (tenantId) {
    //   config.headers["Abp.TenantId"] = tenantId
    // } else {
    //   if (matches && matches[2]) {
    //     config.headers["Abp.TenantName"] = matches[2]
    //   } else {
    //     console.error(`Cant parse tenantName from ${url} url`)
    //   }
    // }
    // /**** END copy code from ajax.ts *******/

    return config
  }

  public async transformResult(url: string, response: AxiosResponse, callBack: any) {
    let apiResp = response.data as AbpApiResponse

    // show error if returned.
    if (!!apiResp.error) {
      abp.log.error({ "Response Error": apiResp.error.message })
    }

    if (!!apiResp.result) {
      response.data = apiResp.result
    }
    return callBack(response)
  }

  protected axiosInterceptResponse(respon:AxiosResponse){
    abp.log.debug({ "axiosInterceptResponse response": respon });
    return respon;
  }

  protected axiosInterceptResponseErr(error:any){
    abp.log.debug({ "axiosInterceptResponseErr error": error });
    return Promise.reject(error);
  }
}


export class ApiException extends Error {
  message: string;
  status: number;
  response: string;
  headers: { [key: string]: any; };
  result: any;

  constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}
